export const paymentMethodToSpanish = (paymentMethod: string) => {
  if (paymentMethod === "cash") return "Efectivo";
  if (paymentMethod === "credit_card") return "Tarjeta de crédito";
  if (paymentMethod === "datafono") return "Datáfono";
  if (paymentMethod === "payment_link") return "Link de pagos";
};
